/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import { theme } from "../theme/theme";

const caretDownActive = require("../svg/caretDownActive.svg");
const caretDownInactive = require("../svg/caretDownInactive.svg");

const StyledCaretButton = styled(Button)`
  border: none;
  background-color: transparent;
  &.MuiButton-root {
    min-width: 0;
    padding: 11px 9px;
    margin: 3px 0px 0px;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  &&& {
    color: ${theme.color.gray800};
    font-family: ${theme.fontFamily};
    font-size: ${theme.fontSize.m};

    li&:hover {
      background-color: ${theme.color.gray100};
    }
  }
`;

type MenuItem = {
  handleClick: () => void;
  name: string;
};

type CaretMenuListProps = {
  disabled?: boolean;
  menuItems: MenuItem[];
};

const CaretMenuList = ({
  disabled,
  menuItems,
}: CaretMenuListProps): React.ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <StyledCaretButton
        aria-controls={open ? "basic-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        data-testid="enable-disable-button"
        disabled={disabled}
        id="basic-menu-button"
        onClick={handleClick}
        type="button"
      >
        <img
          alt="caret down"
          src={disabled ? caretDownInactive : caretDownActive}
        />
      </StyledCaretButton>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        getContentAnchorEl={null}
        id="enable-disable-menu"
        onClose={handleClose}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {menuItems.map(
          (item: MenuItem): React.ReactChild => {
            return (
              <StyledMenuItem
                data-testid={`${item.name}-menu-item`}
                key={item.name}
                onClick={item.handleClick}
              >
                {item.name}
              </StyledMenuItem>
            );
          }
        )}
      </Menu>
    </>
  );
};

CaretMenuList.defaultProps = {
  disabled: false,
};

export default CaretMenuList;
